<template>
  <FusionBaseDialog
    @close="close"
    :open="open"
    :title="$t('subscriptionCancel.cancelCard.title')"
    icon="mdi-alert-circle"
    persistentOverlay
    padded
    data-cy="cancelSubscriptionDialog"
  >
    <SubscriptionCancelCard />
    <template v-slot:actions>
      <SubscriptionCancelActions :activationId="activationId" @close="close" />
    </template>
  </FusionBaseDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SubscriptionCancelCard from './SubscriptionCancelCard.vue'
import SubscriptionCancelActions from './SubscriptionCancelActions.vue'

export default defineComponent({
  name: 'SubscriptionCancelDialog',
  props: {
    open: {
      type: Boolean,
      required: true
    },
    activationId: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  components: {
    SubscriptionCancelCard,
    SubscriptionCancelActions
  },
  methods: {
    close(): void {
      this.$emit('close')
    }
  }
})
</script>
